import { useMutation, useQueryClient } from '@tanstack/react-query';
import { alarmApi } from '../../services/api';
import { alarmKeys } from '../queries/useAlarms';

export function useAcknowledgeAlarm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ alarmId, reason }: { alarmId: string; reason?: string }) =>
      alarmApi.acknowledgeAlarm(alarmId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: alarmKeys.all });
    },
  });
}

export function useResolveAlarm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ alarmId, reason }: { alarmId: string; reason?: string }) =>
      alarmApi.resolveAlarm(alarmId, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: alarmKeys.all });
    },
  });
}

export function useEscalateAlarm() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ alarmId, level, reason }: { alarmId: string; level: number; reason?: string }) =>
      alarmApi.escalateAlarm(alarmId, level, reason),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: alarmKeys.all });
    },
  });
}
